"use client"

import React from 'react';

import styles from "./SingleSegment.module.css"
import {Link} from "@/i18n/routing";
import {Segment} from "@/types/Segments";
import Infos from "@/components/Infos/Infos";
import {endpoint} from "@/utils/api/Conf";
import Image from "next/image";
import useSegmentStatus from "@/utils/hooks/useSegmentStatus";
import {useAppStore} from "@/store/AppStore";
import {useTranslations} from "use-intl";
import HikingIcon from "@mui/icons-material/Hiking";
import {Chip} from "@mui/material";
import {FaRegCheckCircle} from "react-icons/fa";

export default function SingleSegment(props: { data: Segment }) {
  const {data} = props
  const t = useTranslations("Status")
  const user = useAppStore((state) => state.user);
  const status = useSegmentStatus(data.path_id, data.id, user?.access_token)

  // `ended` e `started` sono derivati direttamente da `status.actions`:
  // sticky-true a partire dal primo render in cui appare un'action di
  // tipo "end" (ended) o una qualsiasi action altrimenti (started).
  const ended = status?.actions?.some((itm) => itm.type === "end") ?? false
  const started = !ended && ((status?.actions?.length ?? 0) > 0)


  return <div className={styles.container}>
    <Link href={`/tappa/${data.id}`}>
      <div className={styles.inner}>
        <div style={{position: "relative", height: 100, width: 100, minWidth: 100}}>
          <Image unoptimized style={{objectFit: "cover"}} alt={"featured-image"} fill
                 src={endpoint + `segments/${data.id}/featured-image` || '/PLACEHOLDER-100x100px.png'}/>
        </div>
        <div className={styles.infoWrapper}>
          <h3>{data.name}</h3>
          {ended && <Chip icon={<FaRegCheckCircle/>} size={"small"} label={t("completed")} color="success"
                          variant="outlined"/>}
          {started && <Chip icon={<HikingIcon/>} size={"small"} label={t("started")} color="warning"
                            variant="outlined"/>}
          <Infos iconSize={15} className={styles.infos} data={data}/>
        </div>
      </div>
    </Link>
  </div>
}
